import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 58048473-346E-4473-A18D-36C29B789322
 * name identifier
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/identifier.svg
 * tags
 * - Developer / Languages 
 */
export const IdentifierIcon = createSvgIcon(<><path d="M10 7V9H9V15H10V17H6V15H7V9H6V7H10M16 7C17.11 7 18 7.9 18 9V15C18 16.11 17.11 17 16 17H12V7M16 9H14V15H16V9Z" /></>, 'IdentifierIcon');
export default IdentifierIcon